import { OptimizedImage } from '@/shared/components/OptimizedImage';
import brandedLogo from '@/assets/images/logo/Branded-logo-horizontal-crop.webp';
import { B2B_PORTAL_URL } from '@/shared/utils/constants';
import { FacebookIcon } from '@/assets/Icons/FacebookIcon/FacebookIcon';
import { InstagramIcon } from '@/assets/Icons/InstagramIcon/InstagramIcon';
import { LinkedInIcon } from '@/assets/Icons/LinkedInIcon/LinkedInIcon';

export const Footer = () => {
  const socialLinks = [
    {
      href: import.meta.env.VITE_SOCIAL_FACEBOOK,
      icon: <FacebookIcon size={20} />,
      label: 'Facebook',
    },
    {
      href: import.meta.env.VITE_SOCIAL_INSTAGRAM,
      icon: <InstagramIcon size={20} />,
      label: 'Instagram',
    },
    {
      href: import.meta.env.VITE_SOCIAL_LINKEDIN,
      icon: <LinkedInIcon size={20} />,
      label: 'LinkedIn',
    },
  ].filter(link => link.href);

  const linkGroups = [
    {
      title: 'COMPANY INFO',
      links: [
        { label: 'info@branded-ingredients.com', href: 'mailto:info@branded-ingredients.com' },
        { label: 'privacy policy', href: '/assets/pdf/PrivacyPolicy2026.pdf' },
        { label: 'terms of use', href: '/assets/pdf/BrandedIngredientsTermsConditions2026.pdf' },
        { label: 'about us', href: '/about-us' },
      ],
    },
    {
      title: 'YOUR BRAND & PRICING',
      links: [
        { label: 'price list', href: '/price-list' },
        { label: 'register your brand', href: `${B2B_PORTAL_URL}/auth/registration` },
        { label: 'login', href: `${B2B_PORTAL_URL}/auth/login` },
      ],
    },
    {
      title: 'SEARCH BRANDED INGREDIENTS',
      links: [
        { label: 'news', href: '/news' },
        { label: 'health categories', href: '/health-categories' },
        { label: 'suppliers', href: '/suppliers' },
        { label: 'ingredients', href: '/ingredients' },
        { label: 'events', href: '/events' },
      ],
    },
  ];

  return (
    <footer className='bg-primary mt-17.5 w-full'>
      {/* Main Footer Content */}
      <div className='mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8'>
        {/* Logo */}
        <div className='pb-3 md:w-1/2 lg:w-1/3'>
          <a href='/' className='inline-block'>
            <OptimizedImage
              src={brandedLogo}
              alt='Branded Ingredients'
              priority
              blur={false}
              objectFit='contain'
              className='-ml-4'
            />
          </a>
        </div>
        {/* Separator Line */}
        <div className='mb-6 border-t-2 border-white' />

        {/* Two Column Layout */}
        <div className='grid grid-cols-1 gap-8 md:grid-cols-3'>
          {/* Link Groups */}
          {linkGroups.map(group => (
            <div key={group.title}>
              <h3 className='mb-5 text-sm font-bold tracking-wide text-black'>{group.title}</h3>
              <ul className='items-center gap-x-6 gap-y-2'>
                {group.links.map(link => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className='text-sm font-bold text-white transition-colors hover:text-sky-100'
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Social Icons */}
        {socialLinks.length > 0 && (
          <div className='mt-8 flex gap-4'>
            {socialLinks.map(link => (
              <a
                key={link.label}
                href={link.href}
                target='_blank'
                rel='noopener noreferrer'
                aria-label={link.label}
                className='text-white transition-colors hover:text-sky-100'
              >
                {link.icon}
              </a>
            ))}
          </div>
        )}
      </div>
      {/* Bottom Bar */}
      <div className='mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8'>
        <div className='mb-6 border-t-2 border-white' />
      </div>
      <div className='mx-auto mt-[-45px] max-w-7xl px-4 py-4 sm:px-6 lg:px-8'>
        <div className='flex flex-col items-center justify-center gap-2 text-center text-xs text-white sm:flex-row sm:gap-4'>
          <span>© Branded Ingredients 2026</span>
          <span className='hidden sm:inline'>|</span>
          <span>Registered in the Netherlands No. 6102940</span>
          <span className='hidden sm:inline'>|</span>
          <span>VAT registration No. NL854172786B01</span>
        </div>
      </div>
    </footer>
  );
};
